import Work1 from "../../assets/work-1.svg";
import Work2 from "../../assets/work-2.svg";
import Work3 from "../../assets/work-3.svg";
import Work4 from "../../assets/work-4.svg";
import Work5 from "../../assets/work-5.svg";
import Work6 from "../../assets/work-6.svg";

const Menu = [
  {
    id: 1,
    image: Work1,
    title: "Diaxta Finance Management",
    desc: "Diaxta Finance is a modern web application designed to simplify financial management through intelligent automation. It leverages an AI-powered chatbot to deliver dynamic, real-time responses",
    category: "Design",
    url: "https://beta.diaxta.com/",
  },
  {
    id: 2,
    image: Work2,
    title: "Business Fly",
    desc: "It's dynamic flight search engine tailored for a targeted audience in the UK, offering fast, personalized results to help users find the best flight options with ease.",
    category: "UI/UX",
    url: "https://businessfly.co.uk/",
  },
  {
    id: 3,
    image: Work3,
    title: "MagicMato - AI powered Restro POS",
    desc: "MagicMato is an AI-powered restaurant point-of-sale system designed to streamline operations and enhance the dining experience.",
    category: "UI/UX",
    url: "https://magicmato.com/",
  },
  ,
  {
    id: 4,
    image: Work4,
    title: "White Magic Travels",
    desc: "White Magic Travels is a comprehensive travel planning application that offers personalized itineraries and real-time booking options for users.",
    category: "Design",
    url: "https://www.whitemagictravels.co.uk/",
  },
  ,
  {
    id: 5,
    image: Work5,
    title: "Loansaarthi",
    desc: "Loansaarthi is a comprehensive loan provider website designed to offer users a seamless experience for applying and managing their loans.",
    category: "UI/UX",
    url: "https://loansaarthi.com/",
  },
  ,
  {
    id: 6,
    image: Work6,
    title: "Indmanshoes - Shoes Catalogue",
    desc: "Indmanshoes is a modern e-commerce platform for browsing kids stylish shoes.",
    category: "Design",
    url: "https://indmanshoes.in/",
  },
];

export default Menu;
